/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from '../client/http-client';
import {
  type ErrorResponseDto,
  type OffsetPaginationResponseDtoPointTokenHistoryResponseDto,
  type PointTokenAdditionalIssuanceReqeustDto,
  type PointTokenIssuanceRequestDto,
  type PointTokenResponseDto,
  type PointTokenTransferRequestDto,
  type PointTokenUpdateRequestDto,
  type PointTokenWithUserBalanceResponseDto,
  type SuccessIdResponseDto,
  type UserPointTokenHistoryResponseDto,
  type UserPointTokenResponseDto,
} from '../dto/data-contracts';

export class PointToken<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 포인트를 추가 발행하여 총 발행량을 증가 시킨다.
   *
   * @tags PointToken
   * @name IssueAdditionalPointToken
   * @summary 포인트 토큰 추가 발행
   * @request POST:/v1/point-token-actions/additional-point/issue
   * @secure
   */
  issueAdditionalPointToken = (
    data: PointTokenAdditionalIssuanceReqeustDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/point-token-actions/additional-point/issue`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 포인트 토큰을 유저에게 직접 전송한다.
   *
   * @tags PointToken
   * @name DropPointToken
   * @summary 포인트 토큰 드랍
   * @request POST:/v1/point-token-actions/transfer
   * @secure
   */
  dropPointToken = (
    data: PointTokenTransferRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/point-token-actions/grant`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags PointToken
   * @name GetPointTokensWithUserBalanceByCreatorType
   * @summary 포인트 토큰 리스트 조회 (로그인 유저 잔고 포함)
   * @request GET:/v1/point-tokens
   * @secure
   */
  getPointTokensWithUserBalanceByCreatorType = (params: RequestParams = {}) =>
    this.http.request<PointTokenWithUserBalanceResponseDto[], ErrorResponseDto>(
      {
        path: `/v1/point-tokens`,
        method: 'GET',
        secure: true,
        ...params,
      },
    );
  /**
   * @description 포인트 토큰을 생성한다.
   *
   * @tags PointToken
   * @name IssuePointToken
   * @summary 포인트 토큰 생성
   * @request POST:/v1/point-tokens
   * @secure
   */
  issuePointToken = (
    data: PointTokenIssuanceRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/point-tokens`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 포인트 토큰을 tokenId로 조회한다.
   *
   * @tags PointToken
   * @name GetPointToken
   * @summary 포인트 토큰 조회
   * @request GET:/v1/point-tokens/{tokenId}
   */
  getPointToken = (tokenId: string, params: RequestParams = {}) =>
    this.http.request<PointTokenResponseDto, ErrorResponseDto>({
      path: `/v1/point-tokens/${tokenId}`,
      method: 'GET',
      ...params,
    });
  /**
   * @description 포인트 토큰을 수정한다.
   *
   * @tags PointToken
   * @name UpdatePointTokenSymbol
   * @summary 포인트 토큰 수정
   * @request PUT:/v1/point-tokens/{tokenId}
   * @secure
   */
  updatePointTokenSymbol = (
    tokenId: string,
    data: PointTokenUpdateRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/point-tokens/${tokenId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 유저(파트너)가 발행한 포인트 정보를 조회한다.
   *
   * @tags PointToken
   * @name FindUserIssuedPointToken
   * @summary 유저가 발행한 포인트 정보 조회
   * @request GET:/v1/users/{userId}/issued-point-tokens
   * @secure
   */
  findUserIssuedPointToken = (userId: string, params: RequestParams = {}) =>
    this.http.request<PointTokenResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/issued-point-tokens`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * @description 발행한 토큰에 귀속된 히스토리를 Offset Pagination으로 조회
   *
   * @tags PointToken
   * @name GetOwnedTokenHistoriesByOffsetPagination
   * @summary 발행한 포인트의 수여/회수 히스토리 조회
   * @request GET:/v1/users/{userId}/point-token-histories/{tokenId}
   * @secure
   */
  getOwnedTokenHistoriesByOffsetPagination = (
    userId: string,
    tokenId: string,
    query?: {
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /**
       * 요청 페이지 번호
       * @format int32
       * @min 1
       */
      requestPageNumber?: number;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      OffsetPaginationResponseDtoPointTokenHistoryResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/users/${userId}/point-token-histories/${tokenId}`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 유저가 소유한 포인트 잔고 정보를 조회한다.
   *
   * @tags PointToken
   * @name FindOwnedUserPointTokens
   * @summary 유저가 소유한 포인트 잔고 정보 조회
   * @request GET:/v1/users/{userId}/point-tokens
   * @secure
   */
  findOwnedUserPointTokens = (
    userId: string,
    query?: {
      name?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<UserPointTokenResponseDto[], ErrorResponseDto>({
      path: `/v1/users/${userId}/point-tokens`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 유저가 소유한 특정 포인트 잔고 정보를 조회한다.
   *
   * @tags PointToken
   * @name FindUserPointToken
   * @summary 유저가 소유한 특정 포인트 잔고 정보 조회
   * @request GET:/v1/users/{userId}/point-tokens/{tokenId}
   * @secure
   */
  findUserPointToken = (
    userId: string,
    tokenId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<UserPointTokenResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/point-tokens/${tokenId}`,
      method: 'GET',
      secure: true,
      ...params,
    });
  /**
   * @description 유저가 소유한 특정 토큰 잔고 히스토리를 조회한다.
   *
   * @tags PointToken
   * @name FindUserPointTokenHistories
   * @summary 유저가 소유한 특정 포인트 잔고 히스토리 조회
   * @request GET:/v1/users/{userId}/point-tokens/{tokenId}/histories
   * @secure
   */
  findUserPointTokenHistories = (
    userId: string,
    tokenId: string,
    query: {
      /** @format int32 */
      cursor?: number;
      /** @format int32 */
      limit: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<UserPointTokenHistoryResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/point-tokens/${tokenId}/histories`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
}
